import * as React from 'react';
import moment from 'moment';
import { Button, styled } from '@lib/components';

type Subscription = T.Schema.NativeLoyaltyBilling.Subscription;
type Interval = T.Schema.NativeLoyaltyBilling.Interval;

/** Two full-width buttons, same look as the Uber modal's Settings / Postal Codes tabs. */
export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 15px;
`;

export const InfoBox = styled.div`
  color: #084298;
  background-color: #cfe2ff;
  border: 1px solid #b6d4fe;
  border-radius: 0.25rem;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  font-size: 14px;
  line-height: 20px;
`;

export const PlanSummary = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 15px;
  & .plan-name {
    font-size: 16px;
    font-weight: 600;
    color: #212121;
  }
  & .plan-meta {
    font-size: 14px;
    color: #757575;
  }
`;

export function IntervalToggle(props: { value: Interval; onChange: (v: Interval) => void; disabled?: boolean }) {
  const { value, onChange, disabled } = props;
  return (
    <ToggleRow>
      <Button full={true} type="button" disabled={disabled} color={value === 'month' ? 'primary' : 'primary-inverse'} onClick={() => onChange('month')}>
        Monthly
      </Button>
      <Button full={true} type="button" disabled={disabled} color={value === 'year' ? 'primary' : 'primary-inverse'} onClick={() => onChange('year')}>
        Yearly
      </Button>
    </ToggleRow>
  );
}

export function nativeSubscriptionActive(sub: Subscription | null | undefined): boolean {
  return !!sub && ['active', 'trialing', 'past_due'].indexOf(sub.status) !== -1;
}

export function planName(sub: Subscription): string {
  const level = sub.level === 'organisation' ? 'Organisation-wide' : 'Per Store';
  const interval = sub.interval === 'year' ? 'Yearly' : 'Monthly';
  return `${level} · ${interval}`;
}

/** "Renews on 29 Oct 2026", "Ends on …" once cancelled, or a plain status for non-active plans. */
export function planPeriodText(sub: Subscription): string {
  const date = moment(sub.current_period_end).format('D MMM YYYY');
  if (!nativeSubscriptionActive(sub)) return `Status: ${sub.status}`;
  if (sub.cancel_at_period_end) return `Ends on ${date}`;
  if (sub.status === 'past_due') return `Payment overdue · renews on ${date}`;
  if (sub.status === 'trialing') return `Trial ends on ${date}`;
  return `Renews on ${date}`;
}

export function stripCheckoutParams() {
  const params = new URLSearchParams(window.location.search);
  params.delete('native_loyalty_checkout');
  params.delete('session_id');
  const query = params.toString();
  window.history.replaceState({}, document.title, `${window.location.pathname}${query ? `?${query}` : ''}`);
}

export function readCheckoutParams(): { checkout: string | null; sessionId: string | null } {
  const params = new URLSearchParams(window.location.search);
  return { checkout: params.get('native_loyalty_checkout'), sessionId: params.get('session_id') };
}
